
const countVisibleItems = (items) => items.filter((i) => !!i.isVisible).length;

const seeButtonKey = {
	all: "All",
	less: "Less",
	more: "More",
};

export default {
	props: {
		fetchingMoreResults: {
			required: true,
			type: Boolean,
		},
		items: {
			required: true,
			type: Array,
		},
		firstLimit: {
			required: true,
			type: Number,
		},
		secondLimit: {
			required: true,
			type: Number,
		},
		totalLimit: {
			required: true,
			type: Number,
		},
	},
	computed: {
		shouldShow() {
			return this.totalLimit > this.firstLimit;
		},
		firstLimitIsReached() {
			return countVisibleItems(this.items) === this.firstLimit;
		},
		secondLimitIsReached() {
			return countVisibleItems(this.items) === this.secondLimit;
		},
		limitIsReached() {
			return countVisibleItems(this.items) === this.totalLimit;
		},
		buttonMode() {
			if (this.secondLimitIsReached && !this.limitIsReached) {
				return seeButtonKey.all;
			}

			if (this.firstLimitIsReached && !this.limitIsReached) {
				return seeButtonKey.more;
			}

			return seeButtonKey.less;
		},
		label() {
			return this.$t(`See${this.buttonMode}ButtonText`);
		},
	},
	methods: {
		onClick() {
			this.$emit("click", this.buttonMode);
		},
	},
};
